module.exports = __webpack_public_path__ + "static/media/goodsRefisterLiscence.a5201b09.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/goodsRefisterLiscence.png
// module id = 3996
// module chunks = 0